<template>
  <div :class="classes" v-if="!isClosed" @click="buttonFunc">
    <div>
      <a v-if="!clickButton && clickLabel" @click="clickLabel" :class="labelLinkClasses">
        {{ label }}
      </a>
      <a v-else-if="clickButton" :class="labelLinkClasses">
        {{ label }}
      </a>
      <span v-else :class="labelClasses">
        {{ label }}
      </span>
    </div>
    <div class="tag-bubble-closer" v-if="!closeDisabled">
      <a class="normal font-reduce-1" @click="closeFunc">
        &#x2715;
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tag-bubble-control',
  computed: {
    buttonFunc () {
      if (this.clickButton) {
        return this.clickButton
      }
      return this.emptyFunc
    },
    closeFunc () {
      if (this.clickClose) {
        this.clickClose(this.label)
        return
      }
      return this.defaultCloser
    },
    labelClasses () {
      if (this.labelClass) {
        return this.labelClass
      }
      return ''
    },
    labelLinkClasses () {
      if (this.labelClass) {
        return 'normal ' + this.labelClass
      }
      return 'normal'
    },
    classes () {
      if (this.class) {
        return 'tag-bubble d-flex ' + this.class
      }
      return 'tag-bubble d-flex'
    }
  },
  data () {
    return {
      isClosed: false
    }
  },
  methods: {
    emptyFunc () {
      // intentionally empty
    },
    defaultCloser () {
      this.isClosed = true
    }
  },
  props: [
    'label',
    'labelClass',
    'closeDisabled',
    'class',
    'clickLabel',
    'clickButton',
    'clickClose',
    'closeLabel'
  ]
}
</script>
<style scoped>
.tag-bubble {
    background-color: var(--form-control-bg-color);
    border: 1px var(--form-control-border-color) solid !important;
    border-radius: 6px;
    margin-left: 4px;
    margin-right: 4px;
    margin-top: 4px;
    margin-bottom: 4px;
    font-size: var(--font-reduce-2);
    padding: 3px;
    padding-left: 8px;
    padding-right: 8px;
    min-width: 5px;
    width: fit-content;
    height: 28px;
}
.tag-bubble-closer {
    border-left: 1px var(--form-control-border-color) solid !important;
    padding-left: 7px;
    padding-right: 2px;
    margin-left: 8px;
}
</style>